import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from '../shared/services/crud.service';
import { TableMap } from './table.types';

@Injectable({
    providedIn: 'root'
})
export class TableService extends CrudService<TableMap> {
    constructor(protected http: HttpClient) {
        super(http, '');
    }

    setUrl(url: string) {
        this.apiUrl = url;
    }

    export(obj: any) {
        return this.http.post(`/api/${this.apiUrl}/export`, obj, {
            observe: 'response',
            responseType: 'blob'
        });
    }
}
